import classnames from 'classnames';
import { noop, trim } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { toRequiredLabel } from 'utils';

import Tooltip from '../Tooltip';

export default class Textarea extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    label: PropTypes.string,
    isDisabled: PropTypes.bool,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    tooltipContent: PropTypes.string,
    tooltipTitle: PropTypes.string,
    isValid: PropTypes.bool,
    validationMessage: PropTypes.string,
    isRequired: PropTypes.bool,
    maxLength: PropTypes.number,
    id: PropTypes.string,
    promtText: PropTypes.string,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    isDisabled: false,
    onChange: noop,
    onBlur: noop,
    isRequired: false,
  };

  state = {
    showTooltip: false,
    value: this.props.value,
  };

  componentDidUpdate(prevProps) {
    const { value } = this.props;

    if (prevProps.value !== value) {
      this.updateValue(value);
    }
  }

  updateValue(value) {
    this.setState({ value });
  }

  setShowTooltip = (value) => {
    this.setState({ showTooltip: value });
  };

  validate() {
    const { isValid, validationMessage } = this.props;
    let message = null;

    if (validationMessage) {
      message = (
        <div className={classnames('form_error', { green: isValid, red: !isValid })}>
          {validationMessage}
        </div>
      );
    }

    return message;
  }

  onChange(e) {
    let value = e.target ? e.target.value : e;
    this.setState({ value });
    const { onChange } = this.props;
    if (onChange) {
      onChange(e);
    }
  }

  onBlur = (e) => {
    const { onBlur } = this.props;
    e.target.value = trim(e.target.value);
    onBlur(e);
  };

  onPaste = (e) => {
    const { maxLength } = this.props;
    if (maxLength) {
      e.clipboardData.getData('text/plain').slice(0, maxLength);
    }
  };

  renderTooltip = () => {
    const { tooltipContent, tooltipTitle = null } = this.props;
    let tooltip = null;

    if (tooltipContent) {
      tooltip = (
        <Tooltip
          content={tooltipContent}
          title={tooltipTitle}
          show={this.state.showTooltip}
          onShow={() => this.setShowTooltip(true)}
          onClose={() => this.setShowTooltip(false)}
        />
      );
    }

    return tooltip;
  };

  renderPromt = (promt) => {
    return !promt ? null : <div className="form-file_note">{promt}</div>;
  };

  render() {
    const {
      isDisabled,
      placeholder,
      label,
      isValid,
      isRequired,
      validationMessage,
      maxLength,
      id,
      promtText,
      disabled,
    } = this.props;
    const fieldClassNames = classnames('form_field', 'form_field__text', {
      form_field__error: validationMessage && isValid === false,
      form_field__disable: isDisabled || disabled,
    });

    return (
      <div className="form_item form_item__part">
        <div className="form_label">{isRequired ? toRequiredLabel(label) : label}</div>
        <div className="help-wrap">
          <div className="form_wrapper">
            <textarea
              id={id}
              className={fieldClassNames}
              placeholder={placeholder}
              onChange={(e) => this.onChange(e)}
              onBlur={this.onBlur}
              disabled={isDisabled ? 'disabled' : false}
              value={this.state.value}
              onPaste={this.onPaste}
              maxLength={maxLength}
            />
          </div>
          {this.renderTooltip()}
        </div>
        {this.renderPromt(promtText)}
        {this.validate()}
      </div>
    );
  }
}
